module.exports = __webpack_public_path__ + "img/hr-rock-medium-04.2af64116.png";